<template>
  <v-img
    contain
    width="28"
    height="33"
    class="position-absolute d-inline-flex cursor-pointer soft-version-icon-img"
    :src="image.src"
    :alt="image.alt"
    @click="$emit('click', $event)"
  />
</template>

<script>
export default {
  name: 'SoftVersionImage',
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.soft-version-icon-img {
  top: 0;
  left: 0;
  transform: translateY(-50%);
}
</style>
